import React from 'react';
import { InputGrid } from '../../../../ui/UtilsLayout';
import { useSelector } from 'react-redux';

const LeftPanelHeader = ({
  name,
  setName,
  handleNavigateBack,
  handleTogglePopup,
  iconsPath,
}) => {
  const { window_type } = useSelector((state) => state.window);

  return (
    <div className="left-panel-header">
      <button onClick={handleNavigateBack} className="icon-btn">
        <img
          className="left-icon-btn-img"
          src={iconsPath?.group9Image}
          alt=""
        />
      </button>

      <div className="relative mr-auto flex items-center">
        <InputGrid
          className="w-[110px] h-auto py-1 text-[10px] relative right-2 text-center rounded-[5px] bg-[#444447] max-w-fit focus:outline-none text-white placeholder:text-[#B8B8B8]"
          placeholder="Untitled Project"
          onChange={(e) => {
            setName(e.target.value.substring(0, 50));
          }}
          value={(name ?? '').substring(0, 50)}
        />
      </div>

      {window_type === 'design' && (
        <button onClick={handleTogglePopup} className="icon-btn">
          <img className="icon-btn-img" src={iconsPath?.menuIcon} alt="" />
        </button>
      )}
    </div>
  );
};

export default LeftPanelHeader;

